import { useTranslation } from 'react-i18next'

import { ArrowUDownLeft } from '@phosphor-icons/react'

import { FormatNumber } from '@reveni-io/reveni-ui'

import Statistic from '@/common/components/Statistic/Statistic'
import StatisticGroup from '@/common/components/StatisticGroup/StatisticGroup'

const TotalStats = ({ count, percentage, countText, percentageText, sales, salesOrdersDataActivated }) => {
  const { t } = useTranslation()

  const getStats = () => {
    const columns = [
      {
        value: sales,
        text: t('Unidades vendidas'),
        visible: salesOrdersDataActivated,
        type: 'decimal',
      },
      {
        value: count,
        text: countText || t('Devoluciones'),
        visible: count === 0 || count,
        type: 'decimal',
      },
      {
        value: percentage,
        text: percentageText || t('devoluciones totales'),
        visible: percentage === 0 || percentage,
        type: 'percent',
      },
    ]

    return columns.filter(column => column.visible)
  }

  return (
    <StatisticGroup>
      {getStats().map(stat => (
        <Statistic
          key={stat.text}
          size="small"
          isOutlined={false}
          Icon={ArrowUDownLeft}
          label={stat.text}
          value={Number(stat.value) >= 0 ? <FormatNumber style={stat.type}>{Number(stat.value)}</FormatNumber> : '-'}
          orientation="horizontal"
        />
      ))}
    </StatisticGroup>
  )
}

export default TotalStats
